module.exports = __webpack_public_path__ + "067503335b2865c89681ebbfb44a3684.fbx";